import * as React from "react";
import type { SVGProps } from "react";
const SvgIconOpenFolder = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.06 1.6q-.64.05-1.07.5-.36.37-.44.86C.53 3.1.53 3.73.53 8c0 5.32 0 5.03.09 5.3.05.15.16.36.25.47.21.28.55.5.89.59.21.06.4.06 5.7.05 5.7 0 5.3 0 5.55-.09.43-.15.8-.5.98-.92l.76-2.96c.77-3.1.75-3 .7-3.24-.07-.33-.34-.65-.65-.76-.17-.07-.25-.07-.86-.07h-.6v-.65c0-.76-.01-.77-.16-1.09-.21-.43-.6-.74-1.06-.87l-.16-.04H6.85l-.1-.42c-.15-.63-.2-.75-.34-.98s-.4-.44-.66-.57q-.24-.12-.55-.15c-.14-.01-2.96-.02-3.14 0M2 2.77q-.17.07-.26.23l-.04.08v9.84l.04.08q.08.17.26.23c.1.03.1.03 5.36.03h5.27l.06-.04q.16-.08.23-.21c.03-.07 1.38-5.42 1.38-5.48 0-.02-.49-.02-4.37-.02-4.18 0-4.38 0-4.45.03q-.16.07-.25.21c-.02.05-.17.59-.48 1.85-.28 1.08-.47 1.8-.5 1.85-.1.23-.38.35-.62.29q-.28-.07-.4-.34c-.08-.18-.1-.12.4-2.1l.49-1.86c.17-.49.6-.87 1.13-1.03l.13-.03h3.42l3.42-.01v-.52c0-.32-.01-.55-.02-.6-.03-.16-.16-.3-.31-.36-.05-.02-.53-.02-2.75-.02-1.67 0-2.73-.01-2.8-.02q-.1-.02-.17-.05c-.09-.04-.2-.15-.25-.23q-.04-.08-.21-.78l-.21-.78c-.04-.08-.15-.19-.24-.23-.07-.04-.08-.04-1.63-.04-1.51 0-1.55 0-1.63.03"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconOpenFolder;
